<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-18 18:42:56
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-04-21 14:29:44
-->
<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar v-if="!sidebar.hide" class="sidebar-container" />
    <div :class="{ 'sidebar-hide': sidebar.hide }" class="center-container has-tags-view">
      <div class="app-maincontent">
        <div :class="{ 'fixed-header': appConfig.fixedHeader }">
          <navbar />
        </div>
        <app-main />
        <footer-view />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia'
  // import  {settings} from '@main/common/pinia'
  import { pinias } from '@main/common/pinia'
  import { AppMain, Navbar, Sidebar, FooterView } from './components'

  const { settings } = pinias
  export default {
    name: 'LayoutView',
    components: {
      AppMain,
      Navbar,
      Sidebar,
      FooterView
    },
    computed: {
      ...mapState(settings, ['sidebar', 'appConfig']),
      classObj() {
        return {
          'hide-sidebar': !this.sidebar.opened,
          'open-Sidebar': this.sidebar.opened
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../common/assets/style/layOut';
</style>
